const PSEvents = require('PSEvents');
const GenericEngine = require('GenericEngine');

const PSState = require('PSState');
const SlotUI = require('SlotUI');
const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        popupNode: cc.Node,
        priceLabel: cc.Label,
        buyButton: cc.Button,
    },

    ctor () {
        if (SlotUI.isReplayMode()) {
            this.locked = true;
        } else {
            this.locked = false;
        }
    },

    onLoad () {
        if (!this.popupNode) {
            cc.error('BuyFeaturePopup: popupNode is required');
        }

        PSEvents.onEngineInitialized((data) => this.init(data));

        this.betChangeListener = (state) => this.updateBet(state);
        this.spinRequestListener = () => this.close();
        this.menuOpened = () => this.close();
        this.buyButtonClicked = () => this.open();

        PSEvents.subscribe(PSEvents.BET_CHANGED, this.betChangeListener);
        PSEvents.subscribe(PSEvents.SPIN_REQUEST, this.spinRequestListener);
        PSEvents.subscribe(PSEvents.MENU_OPENED, this.menuOpened);
        PSEvents.subscribe(PSEvents.BUY_BUTTON, this.buyButtonClicked);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.BET_CHANGED, this.betChangeListener);
        PSEvents.unsubscribe(PSEvents.SPIN_REQUEST, this.spinRequestListener);
        PSEvents.unsubscribe(PSEvents.MENU_OPENED, this.menuOpened);
        PSEvents.unsubscribe(PSEvents.BUY_BUTTON, this.buyButtonClicked);
    },

    open () {
        this.popupNode.active = true;
        this.updateBet(PSState.get());
    },

    close () {
        this.popupNode.active = false;
    },

    init(data) {
        this.initialized = true;
        const [purhcaseData] = GenericEngine.getPurchases();
        this.feature = purhcaseData.feature;
        this.price = purhcaseData.price;
        this.availableBetsAmounts = purhcaseData.availableBetsAmounts;

        this.updateBet(data);
    },

    updateBet ({ betAmount }) {
        if (this.betAmount !== betAmount) {
            const cost = this.price * betAmount;
            this.betAmount = betAmount;
            this.priceLabel.string = i18n.formatCurrency(cost);
            this._updateButtonState();
        }
    },

    _updateButtonState () {
        const cost = this.price * this.betAmount;
        const isValidBetAmount = this.availableBetsAmounts.includes(this.betAmount);
        this.buyButton.interactable = isValidBetAmount && cost <= PSState.balance && !this.locked;
    },

    lockButton () {
        this.locked = true;
        if (this.initialized) {
            this._updateButtonState();
        }
    },

    unlockButton () {
        this.locked = false;
        if (this.initialized) {
            this._updateButtonState();
        }
    },

    buyClicked () {
        PSEvents.publish(PSEvents.BUY_REQUEST, { featureId: this.feature, selectedBet: this.betAmount });
    },
});
